import {
  Box,
  Container,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from "@chakra-ui/react";
import { useEffect } from "react";
import { useHistory } from "react-router";
import Login from "../components/Authentication/Login";
import Signup from "../components/Authentication/Signup";
import { Ornament } from "../components/ui/Icons";

const tabStyle = {
  fontFamily: "'Prata', serif",
  fontSize: "15px",
  letterSpacing: "0.14em",
  color: "rgba(36, 61, 39, 0.55)",
  pb: 3,
  borderBottom: "2px solid transparent",
  transition: "all 0.2s ease",
  _hover: { color: "#243D27" },
  _selected: { color: "#8D414B", borderBottomColor: "#8D414B" },
  _focus: { boxShadow: "none" },
};

function Homepage() {
  const history = useHistory();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("userInfo"));

    if (user) history.push("/chats");
  }, [history]);

  return (
    <Container maxW="md" centerContent>
      {/* Типографический логотип */}
      <Box
        className="rise-in"
        d="flex"
        flexDir="column"
        alignItems="center"
        w="100%"
        m="64px 0 32px 0"
      >
        <Text
          className="atika-wordmark"
          fontSize={{ base: "46px", md: "58px" }}
          color="#243D27"
          lineHeight="1"
        >
          А.Т.И.К.А
        </Text>
        <Text
          fontFamily="'Prata', serif"
          fontSize={{ base: "21px", md: "25px" }}
          color="#8D414B"
          letterSpacing="0.35em"
          mt={3}
          ml="0.35em"
        >
          АРТ КЛУБ
        </Text>
        <Box mt={5}>
          <Ornament color="#8D414B" opacity={0.75} />
        </Box>
        <Text
          fontSize="sm"
          color="#243D27"
          opacity={0.65}
          mt={3}
          letterSpacing="0.04em"
        >
          мессенджер для художников
        </Text>
      </Box>

      <Box
        className="rise-in-late"
        bg="#FBF0D9"
        w="100%"
        p={{ base: 6, md: 8 }}
        borderRadius="22px"
        border="1px solid"
        borderColor="#E4D2A6"
        boxShadow="0 30px 70px -24px rgba(36, 61, 39, 0.35), 0 4px 14px rgba(36, 61, 39, 0.06)"
        mb={16}
      >
        <Tabs isFitted variant="unstyled">
          <TabList mb="1.5em" borderBottom="1px solid" borderColor="#E4D2A6">
            <Tab {...tabStyle}>ВХОД</Tab>
            <Tab {...tabStyle}>РЕГИСТРАЦИЯ</Tab>
          </TabList>
          <TabPanels>
            <TabPanel p={0}>
              <Login />
            </TabPanel>
            <TabPanel p={0}>
              <Signup />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </Container>
  );
}

export default Homepage;
